<template>
  <head>
    <meta charset="utf-8" />
    <title>County Biller</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- Bootstrap CSS -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons CSS -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App CSS-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Custom CSS-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- Add Font Awesome for better icons -->
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

  </head>
  <body @contextmenu.prevent data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <NavigationBar/>
    <div class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">
          <!-- Page header -->
          <div class="page-header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h3 class="mb-1">County Biller Auto Reconciliation</h3>
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="dashboard.html">Dashboard</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Auto Reconciliation</li>
                  </ol>
                </nav>
              </div>
              <div>
                <button class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#uploadFile">
                  <i class="mdi mdi-file-upload-outline me-1"></i>
                  Upload Transactions
                </button>
              </div>
            </div>
          </div>

          <!-- Main content card -->
          <div class="card">
            <div class="card-header">
              <div class="d-flex justify-content-between align-items-center">
                <h5 class="card-title mb-0">Reconciliations History</h5>
              </div>
            </div>

            <!-- Search and filters -->
            <div class="card-body border-bottom pb-0">
              <div class="row g-3">
                <div class="col-md-5">
                  <div class="search-box">
                    <input
                        v-model="search"
                        type="text"
                        class="form-control"
                        placeholder="Search by transaction code or description..."
                    >
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>

                <div class="col-md-7">
                  <div class="d-flex gap-3 flex-wrap date-filter">
                    <div class="d-flex align-items-center flex-grow-1">
                      <label class="form-label mb-0 me-2">From:</label>
                      <input
                          v-model="dateFrom"
                          class="form-control"
                          type="date"
                          aria-label="Filter from date"
                      >
                    </div>

                    <div class="d-flex align-items-center flex-grow-1">
                      <label class="form-label mb-0 me-2">To:</label>
                      <input
                          v-model="dateTo"
                          class="form-control"
                          type="date"
                          aria-label="Filter to date"
                      >
                    </div>

                    <div class="dropdown" v-if="getRight('DOWNLOAD RECON HISTORY')">
                      <button class="btn btn-primary btn-sm dropdown-toggle ms-auto" type="button"
                              id="exportDropdown" data-bs-toggle="dropdown" aria-expanded="false"
                              :disabled="loading || ReconTransactions.length === 0">
                        <i class="bx bxs-download me-1"></i>
                        Export Report
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="exportDropdown">
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToPDF">Export to PDF</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToExcel">Export to Excel</a></li>
                        <li><a class="dropdown-item" href="#" @click.prevent="exportToCSV">Export to CSV</a></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Table content -->
            <div class="card-body">
              <!-- Data table -->
              <div class="table-responsive" v-if="ReconTransactions.length > 0 && !loading">
                <table class="table table-hover" id="reconTable">
                  <thead>
                  <tr>
                    <th scope="col">Date</th>
                    <th scope="col">Transaction Code</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Description</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in ReconTransactions" :key="index">
                    <td>{{ item.date }}</td>
                    <td>{{ item.transactionCode }}</td>
                    <td>KES {{ formatPrice(item.amount) }}</td>
                    <td>
                          <span :class="item.available === '1' ? 'unreconciled' : 'reconciled'">
                            {{ item.description }}
                          </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

              <!-- Loading state -->
              <div v-if="loading" class="loading-indicator">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h5 class="mb-3">Loading Data</h5>
                <p class="text-muted text-center" style="max-width: 400px">
                  We're fetching your reconciliation data. This will only take a moment.
                </p>
              </div>

              <!-- Empty state -->
              <div v-if="ReconTransactions.length < 1 && !loading" class="empty-state">
                <img src="/assets/images/no-results.png" alt="No results found">
                <h5 class="mb-3">No Results Found</h5>
                <p class="text-muted" style="max-width: 400px; margin: 0 auto;">
                  We couldn't find any matching records. Try adjusting your search criteria or date filters.
                </p>
              </div>
            </div>

            <!-- Pagination -->
            <div class="card-footer bg-white">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div class="d-flex align-items-center">
                  <label class="mb-0 me-2 text-muted" style="font-size: 0.875rem">Rows per page:</label>
                  <select class="form-select form-select-sm" style="width: auto" v-model="pageSize">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                    <option value="1000">1000</option>
                  </select>
                </div>

                <div v-if="totalPages > 0" class="d-flex align-items-center">
                    <span class="me-3 text-muted" style="font-size: 0.875rem">
                      {{ summary.count }} total records
                    </span>

                  <ul class="pagination pagination-sm mb-0">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                        <i class="bx bx-chevron-left"></i>
                      </a>
                    </li>

                    <li v-for="page in pagination(currentPage, totalPages, 3)"
                        :key="page"
                        class="page-item"
                        :class="{ active: currentPage === page }">
                      <span v-if="page === '...'" class="page-link">{{ page }}</span>
                      <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                    </li>

                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                        <i class="bx bx-chevron-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Upload transactions modal -->
      <div class="modal fade" id="uploadFile" tabindex="-1" aria-labelledby="uploadFileLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="uploadFileLabel">Upload Transactions File</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>

            <div class="modal-body" v-if="!loading">
              <div class="mb-4">
                <div class="form-group mb-3">
                  <label class="form-label">Date Range</label>
                  <div class="row g-2">
                    <div class="col-6">
                      <div class="input-group">
                        <span class="input-group-text">From</span>
                        <input v-model="dateFrom" class="form-control" type="date">
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="input-group">
                        <span class="input-group-text">To</span>
                        <input v-model="dateTo" class="form-control" type="date">
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-3">
                  <label class="form-label">Select File Source</label>
                  <select class="form-select" v-model="statement">
                    <option value="MPESA">MPESA Transactions</option>
                    <option value="KCB">KCB BANK Transactions</option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">Upload File</label>
                  <div class="border rounded p-3 bg-light text-center">
                    <input
                        name="file"
                        type="file"
                        class="d-none"
                        id="transaction-file"
                        ref="fileInput"
                        @change="handleFileChange($event)"
                    />
                    <div v-if="!selectedFile" @click="$refs.fileInput.click()" style="cursor: pointer">
                      <i class="bx bx-cloud-upload text-primary" style="font-size: 2rem"></i>
                      <p class="mb-0 mt-2">
                        Drag files here or <span class="text-primary">browse</span>
                      </p>
                      <p class="text-muted small mb-0">Supported formats: CSV, XLSX</p>
                    </div>
                    <div v-else class="text-start">
                      <div class="d-flex align-items-center">
                        <i class="bx bx-file me-2 text-primary"></i>
                        <div>
                          <p class="mb-0 fw-medium">{{ selectedFile.name }}</p>
                          <p class="text-muted mb-0 small">
                            {{ Math.round(selectedFile.size / 1024) }} KB
                          </p>
                        </div>
                        <button
                            class="btn btn-sm btn-light ms-auto"
                            @click.prevent="selectedFile = null"
                        >
                          <i class="bx bx-x"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Alert messages -->
              <div v-if="message">
                <div v-if="alert.success" class="alert alert-success" role="alert">
                  <i class="bx bx-check-circle me-1"></i>
                  Successfully reconciled: {{ message }}
                </div>
                <div v-if="alert.failed" class="alert alert-danger" role="alert">
                  <i class="bx bx-error-circle me-1"></i>
                  {{ message }}
                </div>
              </div>

              <button
                  @click="uploadExcelToQue()"
                  class="btn btn-primary w-100"
                  :disabled="!selectedFile || loading"
              >
                Upload and Process
              </button>
            </div>

            <!-- Loading state in modal -->
            <div v-if="loading" class="modal-body py-5">
              <div class="text-center">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <h5 class="mb-1">Processing File</h5>
                <p class="text-muted">This may take a moment depending on file size.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              <p class="mb-0 text-muted">&copy; 2025 County Biller</p>
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end">
                Powered by Best Birdy Billing System
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>

</template>
<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import {paysol, execute, execute2, biller, executeDownload, getRight} from "@/api";

import * as XLSX from 'xlsx';


export default {
  name: "CountyBillerReconciliation",
  components: {NavigationBar},
  data() {
    return {
      search: '',
      currentPage: 1,
      totalPages: 0,
      pageSize: 10,
      summary: {
        count: 0,
        total: 0
      },
      totalAmount: null,
      dateTo: '',
      dateFrom: '',
      statement: 'MPESA',
      message: null,
      loading: false,
      selectedFile: null,
      alert: {
        success: false,
        info: false,
        failed: false
      },
      ReconTransactions: []
    };
  },
  mounted() {
    this.getReconciledRecords();
    this.menuAccess();

    this.$watch('dateFrom', function() {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getReconciledRecords();
      }
    });

    this.$watch('dateTo', function() {
      if (this.dateFrom !== '' && this.dateTo !== '') {
        this.getReconciledRecords();
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    pageSize(newPageSize) {
      this.getReconciledRecords();
      const totalItems = this.summary.count;
      const newTotalPages = Math.ceil(totalItems / newPageSize);
      this.totalPages = newTotalPages;
      this.currentPage = 1;
    },
    search() {
      // Use debounce to avoid too many requests while typing
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getReconciledRecords();
      }, 500);
    },
  },
  methods: {
    getRight,
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Recon Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {
            // Access granted
          })
          .catch((e) => {
            console.error("Menu access error:", e);
          });
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = Math.min(start + maxVisibleButtons - 1, totalPages);
      }

      if (end > totalPages) {
        end = totalPages;
        start = Math.max(end - maxVisibleButtons + 1, 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }

      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReconciledRecords();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReconciledRecords();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getReconciledRecords();
      }
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    closeModal() {
      // Reset form data when closing
      this.selectedFile = null;
      this.message = null;
      this.alert.success = false;
      this.alert.failed = false;
      $('#uploadFile').modal('hide');
    },

    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },

    // New methods for client-side export
    exportToPDF() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        const { jsPDF } = window.jspdf;
        const doc = new jsPDF();

        // Add title and date range
        doc.setFontSize(16);
        doc.text("County Biller Reconciliation Report", 14, 15);
        doc.setFontSize(10);
        doc.text(`Date Range: ${this.dateFrom} to ${this.dateTo}`, 14, 22);
        doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 28);

        // Prepare table data
        const tableColumn = ["Date", "Transaction Code", "Amount", "Description", "Status"];
        const tableRows = [];

        this.ReconTransactions.forEach(item => {
          const status = item.available === '1' ? 'Unreconciled' : 'Reconciled';
          const amount = `KES ${this.formatPrice(item.amount)}`;
          const rowData = [
            item.date,
            item.transactionCode,
            amount,
            item.description,
            status
          ];
          tableRows.push(rowData);
        });

        // Generate table
        doc.autoTable({
          head: [tableColumn],
          body: tableRows,
          startY: 35,
          styles: { fontSize: 8, cellPadding: 2 },
          columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 35 },
            2: { cellWidth: 30 },
            3: { cellWidth: 'auto' },
            4: { cellWidth: 25 }
          }
        });

        // Add summary info
        const finalY = doc.lastAutoTable.finalY + 10;
        doc.text(`Total Records: ${this.summary.count}`, 14, finalY);

        // Save PDF
        doc.save(`Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.pdf`);
      } catch (error) {
        console.error("PDF export error:", error);
        alert("Failed to export to PDF. Please try again.");
      }
    },

    exportToExcel() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        // Prepare worksheet data
        const workbook = XLSX.utils.book_new();

        // Format data for Excel
        const formattedData = this.ReconTransactions.map(item => {
          return {
            'Date': item.date,
            'Transaction Code': item.transactionCode,
            'Amount': `KES ${this.formatPrice(item.amount)}`,
            'Description': item.description,
            'Status': item.available === '1' ? 'Unreconciled' : 'Reconciled'
          };
        });

        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Add title and date information in merged cells at the top
        XLSX.utils.sheet_add_aoa(worksheet, [
          ['County Biller Reconciliation Report'],
          [`Date Range: ${this.dateFrom} to ${this.dateTo}`],
          [`Generated on: ${new Date().toLocaleString()}`],
          [],  // Empty row before data
        ], { origin: 'A1' });

        // Set column widths
        const columnWidths = [
          { wch: 12 },  // Date
          { wch: 20 },  // Transaction Code
          { wch: 15 },  // Amount
          { wch: 50 },  // Description
          { wch: 12 },  // Status
        ];
        worksheet['!cols'] = columnWidths;

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Reconciliation');

        // Export as XLSX
        XLSX.writeFile(workbook, `Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.xlsx`);
      } catch (error) {
        console.error("Excel export error:", error);
        alert("Failed to export to Excel. Please try again.");
      }
    },

    exportToCSV() {
      if (!this.dateFrom || !this.dateTo) {
        alert("Please select a date range first");
        return;
      }

      if (this.ReconTransactions.length === 0) {
        alert("No data available to export");
        return;
      }

      try {
        // Format data for CSV
        const formattedData = this.ReconTransactions.map(item => {
          return {
            'Date': item.date,
            'Transaction Code': item.transactionCode,
            'Amount': `KES ${this.formatPrice(item.amount)}`,
            'Description': item.description,
            'Status': item.available === '1' ? 'Unreconciled' : 'Reconciled'
          };
        });

        // Define fields for CSV
        const fields = ['Date', 'Transaction Code', 'Amount', 'Description', 'Status'];

        // Use papaparse or similar lib for CSV creation
        const csvContent = this.convertArrayToCSV(formattedData, fields);

        // Create blob and download
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', `Reconciled_Records_${this.dateFrom}_to_${this.dateTo}.csv`);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("CSV export error:", error);
        alert("Failed to export to CSV. Please try again.");
      }
    },

    // Helper function to convert array to CSV
    convertArrayToCSV(data, fields) {
      // Create header row
      let csv = fields.join(',') + '\r\n';

      // Add data rows
      data.forEach(item => {
        const row = fields.map(field => {
          // Escape quotes and wrap in quotes if contains comma or quote
          const value = item[field] ? item[field].toString() : '';
          if (value.includes(',') || value.includes('"')) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csv += row.join(',') + '\r\n';
      });

      return csv;
    },

    getReconciledRecords() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getReconciledRecords");
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("search", this.search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.ReconTransactions = res.data.data.ReconTransactions;
              this.summary = res.data.data.summary;
              this.totalPages = Math.ceil(this.summary.count / this.pageSize);
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error("Error fetching records:", e);
          });
    },

    uploadExcelToQue() {
      if (!this.selectedFile) {
        alert("Please select a file to upload");
        return;
      }

      if (!this.dateFrom || !this.dateTo) {
        alert("Please select date range");
        return;
      }

      if (!this.statement) {
        alert("Please select a statement type");
        return;
      }

      this.loading = true;
      const data = new FormData();
      data.append("function", "uploadExcelToQue");
      data.append("file", this.selectedFile);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("statement", this.statement);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.message = res.data.message;
              this.alert.success = true;
              this.alert.failed = false;
              this.getReconciledRecords();
              // Auto-close modal after success
              setTimeout(() => {
                this.closeModal();
              }, 3000);
            } else {
              this.message = res.data.message;
              this.alert.failed = true;
              this.alert.success = false;
            }
          })
          .catch((e) => {
            this.loading = false;
            this.message = "Upload failed. Please try again.";
            this.alert.failed = true;
            this.alert.success = false;
            console.error("Upload error:", e);
          });
    }
  },
};
</script>

<style scoped>
/* Custom styles for improved UI */
.page-header {
  background-color: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card {
  border: none;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
}

.card-header {
  background-color: #fff;
  border-bottom: 1px solid #f1f1f1;
  padding: 1rem 1.5rem;
}

.search-box .form-control {
  padding-left: 2.5rem;
  border-radius: 50rem;
}

.search-box .search-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.date-filter {
  border-radius: 0.4rem;
  border: 1px solid #e2e8f0;
  padding: 0.5rem;
  background-color: #f8fafc;
}

table th {
  font-weight: 600;
  font-size: 0.9rem;
}

.reconciled {
  color: #10b981 !important;
  font-weight: 500;
}

.unreconciled {
  color: #2563eb !important;
  font-weight: 500;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  border-radius: 0.25rem;
  margin: 0 0.2rem;
}

.page-item.active .page-link {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.empty-state {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-state img {
  max-width: 200px;
  margin-bottom: 1.5rem;
}

.loading-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
}

.btn-primary {
  background-color: #4f46e5;
  border-color: #4f46e5;
}

.btn-primary:hover {
  background-color: #4338ca;
  border-color: #4338ca;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .date-filter {
    flex-direction: column;
    gap: 0.5rem;
  }

  .date-filter input {
    width: 100%;
  }
}

/* Export dropdown styling */
.dropdown-menu {
  border: none;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 0.5rem;
  padding: 0.5rem 0;
}

.dropdown-item {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  color: #4b5563;
  transition: all 0.2s ease;
}

.dropdown-item:hover {
  background-color: #f3f4f6;
  color: #4f46e5;
}

.dropdown-item:active {
  background-color: #ede9fe;
  color: #4f46e5;
}

/* Table styling improvements */
.table {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
}

.table th {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.75rem 1rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
}

.table td {
  padding: 1rem;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.table tbody tr:hover {
  background-color: #f9fafb;
}

/* Button improvements */
button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

/* Modal styling enhancements */
.modal-content {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
}

.modal-header {
  border-bottom: 1px solid #f3f4f6;
  padding: 1.25rem 1.5rem;
}

.modal-title {
  font-weight: 600;
  color: #111827;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  border-top: 1px solid #f3f4f6;
  padding: 1.25rem 1.5rem;
}

/* Form controls styling */
.form-label {
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.form-control, .form-select {
  border-color: #e5e7eb;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

.form-control:focus, .form-select:focus {
  border-color: #a5b4fc;
  box-shadow: 0 0 0 0.25rem rgba(79, 70, 229, 0.1);
}

.input-group-text {
  background-color: #f9fafb;
  border-color: #e5e7eb;
  color: #6b7280;
}
</style>

